var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBusinessman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    viewBox: "0 0 490.969 490.969",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M341.784,138.869c1.6-4.6,2.9-9.2,3.7-13.8c14.4-86.6-28.2-89.6-28.2-89.6s-7.1-13.6-25.7-23.9    c-12.5-7.4-29.9-13.1-52.8-11.2c-7.4,0.4-14.4,1.8-21,4c-8.4,2.8-16.1,7-23.1,11.8c-8.6,5.4-16.7,12.1-23.8,19.7    c-11.3,11.5-21.4,26.5-25.7,45.1c-3.7,13.9-2.8,28.4,0.2,44.1c0.8,4.6,2,9.1,3.7,13.8c-8.5-0.8-18.6,4.1-9.1,37.6    c6.8,24.5,13.2,31.3,18.1,31.7c4.5,29.1,26.9,66.1,63.8,79.1c15.1,5.3,31.7,5.3,46.8-0.1c36.3-13.1,59.5-50,64-79    c4.9-0.4,11.3-7.3,18.2-31.7C360.384,142.969,350.284,138.069,341.784,138.869z",
    fill: "#4b5563",
    "data-original": "#000000",
    style: {},
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M413.084,321.869c-51.9-13.2-94.1-42.9-94.1-42.9l-32.9,104.1l-6.2,19.6l-0.1-0.3l-5.4,16.6l-17.4-49.3    c42.7-59.6-8.6-59-11.5-58.9c-2.9-0.1-54.2-0.7-11.5,58.9l-17.4,49.3l-5.4-16.6l-0.1,0.3l-6.2-19.6l-32.9-104.1    c0,0-42.2,29.7-94.1,42.9c-38.7,9.8-40.6,54.5-39,76.7c-0.2,0,2.1,30,4.3,43.2c0,0,75.6,49.1,202.2,49.2    c126.6,0,202.2-49.2,202.2-49.2c2.3-13.2,4.5-43.2,4.5-43.2C453.684,376.469,451.784,331.769,413.084,321.869z",
    fill: "#4b5563",
    "data-original": "#000000",
    style: {},
    className: ""
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessman);
export default __webpack_public_path__ + "static/media/businessman.4e4cdd5a.svg";
export { ForwardRef as ReactComponent };